import React from "react";
import { Radio } from "antd";

//import multilanguage library
import { useTranslation } from 'react-i18next'

// Styles
import { Wrapper } from "./styles";

const SelectComponent = ({ values, defaultValue, callback }) => {
  //To translate text
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Radio.Group value={defaultValue} onChange={callback}>
        {values &&
          values.map(value => (
            <Radio.Button key={value.key} value={value.key}>
              {t('labels.'+value.value)}
            </Radio.Button>
          ))}
      </Radio.Group>
    </Wrapper>
  );
};
export default SelectComponent;
